import axios from 'axios'

// 创建axios实例
const service = axios.create({
    //baseURL: process.env.BASE_API, // api的base_url
    timeout: 100000                  // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
    let canaryFlag = localStorage.getItem("canaryFlag");
	let noCanary = sessionStorage.getItem("noCanary")|| canaryFlag == '1' ? '0' : '1';
    config.headers['Content-Type'] = 'application/json;charset=UTF-8';
	let accessToken = sessionStorage.getItem("pa.accessToken");
	alert(accessToken);
    config.headers['accessToken'] = accessToken;
    config.headers['channel'] = '2';
    config.headers['canary'] = canaryFlag;
    config.headers['no-canary'] = noCanary;
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})


service.interceptors.response.use(
    response => {
        return response.data
    },
    error => {
        let resStatus = error.response.data.status;
		alert('err' + error);
        return Promise.reject(error)
    }
);
export default service
